import {
    CELL_TYPE,
    SEQUENCE_START,
} from './editor.constants';

export const displayLabel = (tab, cellName, isSequence) => {
    if (tab === CELL_TYPE.THEN && cellName === SEQUENCE_START && !isSequence) {
        return 'funnel.sidebar.then.cell.start.label.empty';
    }

    return `funnel.sidebar.${tab}.cell.${cellName}.label`;
};
